export default __webpack_public_path__ + "static/node-c093162c9bbf4e416c221eab1d5e3763.png";